// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import omit from 'lodash/omit'
import { Paper } from '@mui/material'
import { i18n } from '../../index'
import StationPage from './StationPage'
import StationForm from './StationForm'
import css from './stationPage.css'

function StationGeneralPage() {
  return (
    <StationPage title={i18n.t('admin.stations.title.generalPage')}>
      {({ station }) => (
        <Paper>
          <div className={css.inner}>
            <StationForm data={omit(station, ['users'])} />
          </div>
        </Paper>
      )}
    </StationPage>
  )
}

export default StationGeneralPage
